<template>
  <v-dialog :value="value" @input="$emit('input', $event)" :attach="dialogRoot" v-bind="$attrs" v-on="$listeners">
    <template slot="activator">
      <slot name="activator" />
    </template>

    <template>
      <slot />
    </template>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      value: Boolean,
      isLoading: Boolean,
    },
    data () {
      return {
        dialogRoot: window['drawer-dialog-root']
      }
    },

    watch: {
      value (val) {
        document.documentElement.style.overflow = val ? 'hidden' : ''
      },
      isLoading (val, oldVal) {
        if (oldVal && !val) {
          this.$emit('input', false)
        }
      }
    }
  }
</script>
